import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmeyoCallingComponent } from './ameyo-calling.component';



@NgModule({
  declarations: [
    AmeyoCallingComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[AmeyoCallingComponent],
  providers:[]
})
export class AmeyoCallingModule { }
